import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-download-image',
    templateUrl: './dialog-download-image.component.html',
    styleUrls: ['./dialog-download-image.component.scss']
})
export class DialogDownloadImageComponent {
    constructor(public dialogRef: MatDialogRef<DialogDownloadImageComponent>) { }
    public imageType: 'base' | 'merged' = 'merged';
}
